export default "__VITE_ASSET__BpP3dTEO__"